module.exports = __webpack_public_path__ + "img/中国交通运输协会.53f0333f.png";